document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.ssicc-slider');

    /** Desktop (992px+): 2 cards per slide. Below that: 1 card per slide. */
    function getLayoutMode() {
        return window.matchMedia('(min-width: 992px)').matches ? 'desktop' : 'compact';
    }

    function cardsPerPage(mode) {
        return mode === 'desktop' ? 2 : 1;
    }

    function groupCards(cards, perPage) {
        const groups = [];

        for (let i = 0; i < cards.length; i += perPage) {
            groups.push(cards.slice(i, i + perPage));
        }

        return groups;
    }

    function collectCardsInOrder(wrapper) {
        return Array.from(wrapper.querySelectorAll('.ssicc-card'));
    }

    function getAnchorCardIndex(wrapper, swiper) {
        if (!swiper || swiper.destroyed || typeof swiper.activeIndex !== 'number') {
            return 0;
        }

        const slides = wrapper.querySelectorAll(':scope > .swiper-slide');
        let idx = 0;

        for (let i = 0; i < swiper.activeIndex && i < slides.length; i++) {
            idx += slides[i].querySelectorAll('.ssicc-card').length;
        }

        return idx;
    }

    function slideIndexContainingCard(groups, firstCardIndex) {
        let offset = 0;

        for (let i = 0; i < groups.length; i++) {
            const n = groups[i].length;
            if (firstCardIndex >= offset && firstCardIndex < offset + n) {
                return i;
            }
            offset += n;
        }

        return 0;
    }

    function buildSlidesFromGroups(wrapper, groups) {
        const slides = groups.map((group) => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide ssicc-page';

            const inner = document.createElement('div');
            inner.className = 'ssicc-page-inner';

            group.forEach((card) => inner.appendChild(card));
            slide.appendChild(inner);

            return slide;
        });

        wrapper.replaceChildren(...slides);
    }

    function mountSlider(slider) {
        const wrapper = slider.querySelector('.swiper-wrapper');
        const paginationEl = slider.querySelector('.swiper-pagination');

        if (!wrapper || !paginationEl) {
            return;
        }

        const cards = collectCardsInOrder(wrapper);

        if (!cards.length) {
            return;
        }

        const mode = getLayoutMode();
        const prevSwiper = slider._ssiccSwiper;

        let anchorCardIndex = 0;
        if (prevSwiper && !prevSwiper.destroyed) {
            anchorCardIndex = getAnchorCardIndex(wrapper, prevSwiper);
            prevSwiper.destroy(true, true);
        }
        slider._ssiccSwiper = null;

        const ordered = cards.slice();
        wrapper.replaceChildren(...ordered);

        const groups = groupCards(ordered, cardsPerPage(mode));
        buildSlidesFromGroups(wrapper, groups);

        slider.dataset.ssiccLayoutMode = mode;

        const targetSlide = slideIndexContainingCard(groups, anchorCardIndex);

        const swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 500,
            watchOverflow: false,
            initialSlide: Math.min(targetSlide, Math.max(0, groups.length - 1)),
            pagination: {
                el: paginationEl,
                clickable: true,
            },
        });

        slider._ssiccSwiper = swiper;
    }

    function debounce(fn, ms) {
        let t;
        return function () {
            clearTimeout(t);
            t = setTimeout(fn, ms);
        };
    }

    function subscribeMediaQuery(mm, handler) {
        if (typeof mm.addEventListener === 'function') {
            mm.addEventListener('change', handler);
        } else if (typeof mm.addListener === 'function') {
            mm.addListener(handler);
        }
    }

    sliders.forEach((slider) => {
        mountSlider(slider);

        const onResize = debounce(() => {
            const mode = getLayoutMode();
            if (mode !== slider.dataset.ssiccLayoutMode) {
                mountSlider(slider);
            }
        }, 150);

        window.addEventListener('resize', onResize);
        subscribeMediaQuery(window.matchMedia('(min-width: 992px)'), () => {
            const mode = getLayoutMode();
            if (mode !== slider.dataset.ssiccLayoutMode) {
                mountSlider(slider);
            }
        });
    });
});
